<div class="flex-grow-1">
  <div
    class="d-flex align-items-center justify-content-start w-100 p-3 fs-18px font-weight-bold border-bottom border-color-grey secalt-bg"
  >
    <top-bar-mobile-hamburger-menu
      class="mr-15px d-lg-none d-inline-block"
    ></top-bar-mobile-hamburger-menu>
    <div>
      <h3 class="mb-1 fs-24px font-weight-semibold">Give a Diamond</h3>
      <h5 class="fs-15px fc-muted">Step 5 of 6</h5>
    </div>
  </div>
  <!-- Top Bar -->
  <div>
    <div class="p-3 fs-15px">
      <p>Diamonds are tips that send money directly to the poster.</p>
      <p class="mt-3">
        <b>Tap the diamond button to give your first diamond!</b>
      </p>
    </div>
  </div>

  <div style="margin-top: -15px">
    <simple-center-loader *ngIf="loading"></simple-center-loader>
    <div *ngIf="!loading">
      <feed-post
        [post]="post"
        [includePaddingOnPost]="true"
        [contentShouldLinkToThread]="false"
        [showLeftSelectedBorder]="true"
        [cardStyle]="true"
        [inTutorial]="true"
        (diamondSent)="onDiamondSent()"
      ></feed-post>
    </div>
    <div
      *ngIf="
        !globalVars.loggedInUser?.MustCompleteTutorial ||
        globalVars.loggedInUser?.IsAdmin
      "
      (click)="globalVars.skipTutorial()"
      class="p-15px"
    >
      <a class="btn btn-outline-primary btn-lg fs-18px text-left"> Exit </a>
    </div>

    <!-- SPACER FOR BOTTOM BAR ON MOBILE -->
    <div class="global__bottom-bar-mobile-height"></div>
    <div class="global__bottom-bar-mobile-height"></div>
  </div>
</div>
